export default "__VITE_ASSET__ddf351ad__"